$(document).ready(function() {
  // Functions for mobile menu slideout
  $("html").on("click", ".pc-mp-header--menu-button-container", function() {
    $('.pc-mp-header--menu-sections-container').toggleClass("opened");
    $('body').toggleClass("no-scroll");
  });
});
